module.exports = __webpack_public_path__ + "static/media/Салимова А.Е..8ce366d2.pdf";